import React, { useState } from "react";
import {
  Table, TableBody, TableCell, TableHead, TableRow, Card, Box, Button,
  TextField, MenuItem, Select, FormControl, InputLabel, Grid, Paper
} from "@material-ui/core";
import { withStyles, makeStyles } from '@material-ui/core/styles';
import SubActivityService from "./Locality/Service/subActivityService";
import AddClassService from "./Locality/Service/addClassService";
import SectionService from "./Locality/Service/sectionService";
import PageTitle from "../../components/PageTitle/PageTitle";

import { useEffect } from 'react';
import ActivityService from "./Locality/Service/activityService";
import SuperActivityService from "./Locality/Service/superActivityService"
import StudentService from "./Locality/Service/studentService"
const statuses = ["P", "WA", "WI", "M"]; // Presented, Work with Assistance, etc.
const statusLabels = {
  P: "Presented",
  WA: "Works with Assistance",
  WI: "Works Independently",
  M: "Mastered",
};

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: "#0f3b62ad",
    color: theme.palette.common.white,
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);
const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: 200,
  },
}));

export default function ActivityTrackerTable() {
  const classes = useStyles();
  const [allSuperActivities, setAllSuperActivities] = useState([]);

  const [activityList, setActivityList] = useState([]);
  const [studentsList, setstudentsList] = useState([]);
  var [classId, setClassId] = useState("");
  const [sectionId, setSectionId] = useState("");
  const [sectionList, setSectionList] = useState([]);
  const [addSuperActivityList, setAddSuperActivityList] = useState([]);
  const [studentList, setStudentList] = useState([]);
  var [isLoading, setIsLoading] = useState(false);
  const [addClassList, setAddClassList] = useState([]);
  var [studentId, setStudentId] = useState("");
  const [selectedKey, setSelectedKey] = useState("");
  const keyOptions = [
        { label: 'Strong area', value: 'M,WI' },
        { label: 'Developing area', value: 'WA' },
        { label: 'Needs attention', value: 'P' },
    ];
  const [activeTab, setActiveTab] = useState('');
  const userDetails = JSON.parse(localStorage.getItem("userDetail")) || {};
  useEffect(() => {
    getAddClassList();
   
   

    return () => {
      setStudentList([]);
      setAddSuperActivityList([]);
      setActivityList([]);
    }
  }, []);
  const colorMap = {
   "P": "#5C9882",
        "WI": "#E6B163",
        "WA": "#A75C9C",
        "M": '#147ad482'
  };
  const onSubmit = (data) => {
    setIsLoading(true); // Start loading

    const keys = {
      schooleId: userDetails.schooleId,
      isFuturePlanning: false,
      isInitLoad: true,
      superActivityId: data,
      studentId: studentId,
      classId: classId,
      sectionId: sectionId || userDetails.sectionId || undefined,
      startDate: "",
      endDate: "",
      status: true,
      key:selectedKey

    };

    ActivityService.findActivityReports(keys)
      .then((result) => {
       ActivityService.findActivityReports(keys)
        setActivityList(result);

        const allStudents = [];
        const allActivities = [];
        debugger
        result.forEach(activity =>
          activity.activityList.forEach(rec => {
            const student = rec.studentId;
            if (student && !allStudents.find(s => s._id === student._id)) {
              allStudents.push(student);
            }
          })
        );
        setstudentsList(allStudents);
        
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {
        setIsLoading(false); // End loading
      });
  };

  const getSectionListByClass = (selectedClassId) => {
    if (!selectedClassId) {
      setSectionList([]);
      setSectionId("");
      return;
    }
    SectionService.findSectionList({
      schooleId: userDetails.schooleId,
      classId: selectedClassId,
    })
      .then((res) => {
        let list = Array.isArray(res) ? res : [];
        if (userDetails.role === "TEACHER" && userDetails.sectionId) {
          list = list.filter(
            (s) => String(s._id) === String(userDetails.sectionId)
          );
        }
        setSectionList(list);
        if (userDetails.role === "TEACHER" && userDetails.sectionId && list.length > 0) {
          setSectionId(userDetails.sectionId);
        }
      })
      .catch(() => {
        setSectionList([]);
      });
  };

  const getAddClassList = (event) => {
    AddClassService.getAllAddClass(userDetails.schooleId).then((res) => {
      let list = res;
      if (userDetails.role === "TEACHER") {
        list = list.filter(c => c._id === userDetails.classId);
      }
      setAddClassList(list);

      if (userDetails.role === "TEACHER" && userDetails.classId) {
        const selectedClassId = userDetails.classId;
        const teacherSectionId = userDetails.sectionId || "";
        setClassId(selectedClassId);
        setSectionId(teacherSectionId);
        getSectionListByClass(selectedClassId);
        getSuperActivityList(selectedClassId);
        getStudentList({ target: { value: selectedClassId } }, teacherSectionId || undefined);
      } else if (list.length > 0) {
        const defaultClassId = list[0]._id;
        setClassId(defaultClassId);
        setSectionId("");
        getSectionListByClass(defaultClassId);
        getSuperActivityList(defaultClassId);
        getStudentList({ target: { value: defaultClassId } });
      }
    }).catch((err) => {
      // setError(err.message);
    });
  }

  const getSuperActivityList = async (classId) => {
    const userDetails = JSON.parse(localStorage.getItem("userDetail"));
    try {
      const res = await SuperActivityService.getAllSuperActivityById(userDetails.schooleId,{classId:classId});
      setAllSuperActivities(res); // Save all to filter later

      // Initial filter (if classId already set)
      if (classId) {
        const filtered = res.filter(item => item.classId?._id === classId);
        setAddSuperActivityList(filtered);
        if (filtered.length > 0) {
          setActiveTab(filtered[0]._id);
          onSubmit(filtered[0]._id);
        }
      }
    } catch (err) {
      console.error(err);
    }
  };
// const getSuperActivityList = async ( classId) => {
//         const userDetails = JSON.parse(localStorage.getItem("userDetail"));
//         try {
//             const res = await SuperActivityService.getAllSuperActivityById(userDetails.schooleId, { classId: classId });
//             setAddSuperActivityList(res);

//             if (res.length > 0) {
//                 setActiveTab(res[0]._id);
//                 onSubmit(res[0]._id,  classId);
//             }
//         } catch (err) {
//             console.error(err);
//         }
//     };

  const getStudentList = (event, overrideSectionId) => {
    const selectedClassId = event?.target?.value || classId;
    const body = { classId: selectedClassId };
    const effectiveSectionId =
      overrideSectionId !== undefined
        ? overrideSectionId
        : sectionId || userDetails.sectionId || undefined;
    if (effectiveSectionId) {
      body.sectionId = effectiveSectionId;
    }

    StudentService.getAllStudentById(userDetails.schooleId, body)
      .then((res) => {
        const studentDetails = res.map((student) => ({
          _id: student._id,
          studentName: `${student.firstName} ${student.lastName}`,
          status: true,
        }));
        setStudentList(studentDetails);
      })
      .catch((err) => {
        console.error("Error fetching students:", err);
      });
  };

  const handleTabClick = (superActivityId) => {

    setActiveTab(superActivityId);
    onSubmit(superActivityId);
  };
  const getStudentReportList = () => {
    const userDetails = JSON.parse(localStorage.getItem("userDetail"));

    if (studentId == '') {
      alert("Please Select Student");
      return;
    }
    const getstudentId = { "studentId": studentId, };

    SubActivityService.getStudentReport(getstudentId).then((res) => {
      // const blob = new Blob(res.pdfBuffer);
      const buffer = Buffer.from(res.pdfBuffer);
      const blob = new Blob([buffer]);
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      document.body.appendChild(a);
      a.style = "display: none";
      a.href = url;
      a.download = "studentreport.pdf";
      a.click();
      window.URL.revokeObjectURL(url);
      // const blob = new Blob([res.pdfBuffer]);
      // saveAs(blob, 'filename.pdf');
      // const file = new File(res.pdfBuffer, 'filename.txt', { type: 'text/plain' });
      // setStudentReportList(res);
    }).catch((err) => {
      alert(err.response.data.message)
    });
  }
  return (
     
    <Paper style={{ padding: 20 }}>
 <PageTitle title="Activity Performance Progress"  />
      <Card sx={{ maxWidth: 345 }}>
        <Box style={{ margin: 15, }} >


          <Grid container spacing={2} columns={12} style={{ margin: 10 }}  >
            <Grid item xs={12} sm={6} md={2}  >
              <FormControl className={classes.formControl} style={{ width: 160 }}
              >
                <InputLabel id="demo-simple-select-label">Select Class</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  name="classId"
                  label="selectClass"

                  onChange={e => {
                    const selectedClassId = e.target.value;
                    setClassId(selectedClassId);
                    setSectionId("");
                    getSectionListByClass(selectedClassId);
                    getStudentList(e); // fetch students for selected class

                    // Filter super activities for selected class
                    const filtered = allSuperActivities.filter(
                      item => item.classId?._id === selectedClassId
                    );
                    setAddSuperActivityList(filtered);
 getSuperActivityList(selectedClassId)
                    if (filtered.length > 0) {
                      setActiveTab(filtered[0]._id);
                      onSubmit(filtered[0]._id);
                    } else {
                      setActivityList([]);
                      setActiveTab("");
                    }
                  }}
                  value={classId}
                >
                  <MenuItem value="">
                    <em>None</em>
                  </MenuItem>

                  {addClassList.map(({ _id, className }) => (
                    <MenuItem key={_id} value={_id}>{className}

                    </MenuItem>
                  ))}
                </Select>
              </FormControl>

            </Grid>
            <Grid item xs={12} sm={6} md={2}>
              <FormControl className={classes.formControl} style={{ width: 160 }}>
                <InputLabel id="section-select-label">Select Section (Optional)</InputLabel>
                <Select
                  labelId="section-select-label"
                  id="section-select"
                  value={sectionId}
                  onChange={(e) => {
                    const newSectionId = e.target.value;
                    setSectionId(newSectionId);
                    if (classId) {
                      getStudentList({ target: { value: classId } }, newSectionId || undefined);
                    }
                  }}
                  disabled={!classId || sectionList.length === 0}
                >
                  <MenuItem value="">
                    <em>None</em>
                  </MenuItem>
                  {sectionList.map(({ _id, sectionName }) => (
                    <MenuItem key={_id} value={_id}>
                      {sectionName}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6} md={3}  >
              <FormControl variant="standard" fullWidth>
                <InputLabel id="studentName">Student Name</InputLabel>
                <Select
                  labelId="studentName"
                  id="studentName"
                  label="Student Name"
                  name="studentId"
                  value={studentId}
                  onChange={e => { setStudentId(e.target.value) }}

                >
                  <MenuItem value="">
                    <em>None</em>
                  </MenuItem>
                  {studentList.map(({ index, _id, studentName }) => (
                    <MenuItem key={index} value={_id}>{studentName}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
             <Grid item xs={6} sm={6} md={3}  >
<FormControl variant="standard" fullWidth>
                            <InputLabel id="demo-simple-select-standard-label">Select Key</InputLabel>
                            <Select
                                labelId="demo-simple-select-standard-label"
                                id="demo-simple-select-standard"
                                label="Key"
                                name="key"
                               value={selectedKey}
  onChange={(e) => setSelectedKey(e.target.value)}
                               
                            >
                                <MenuItem value="">
                                    <em>None</em>
                                </MenuItem>
                                {keyOptions.map((option) => (
                                    <MenuItem key={option.value} value={option.value}>
                                        {option.label}
                                    </MenuItem>

                                ))}
                            </Select>
                        </FormControl>
                        </Grid>
            <Grid item xs={12} sm={6} md={2}>
              <Button style={{ backgroundColor: 'rgb(15 59 98)', color: 'white' }}
                type="button"

                onClick={() => onSubmit(activeTab)} variant="contained"
              >
                Search</Button>
            </Grid>
          </Grid>



        </Box>
      </Card>
      <br></br>
      <div className="overflow-x-auto activity-record p-4 space-y-6">
        <div>
          <h2 className="text-xl font-bold mb-2 text-gray-700">Area Of Work</h2>

        </div>
        <br></br>
        <div style={{ overflowX: 'auto', whiteSpace: 'nowrap' }}>
          <div style={{ display: 'inline-flex', gap: '10px', paddingBottom: '10px' }}>
            {addSuperActivityList.map((area) => {
              const isActive = activeTab === area._id;
              return (
                <button
                  key={area._id}
                  onClick={() => handleTabClick(area._id)}
                  style={{
                    padding: '10px 16px',
                    borderBottom: isActive ? '3px solid rgb(15 59 98)' : '3px solid transparent',
                    backgroundColor: isActive ? '#DBEAFE' : 'transparent',
                    color: isActive ? 'rgb(15 59 98)' : '#4B5563',
                    fontWeight: '600',
                    borderRadius: '6px 6px 0 0',
                    whiteSpace: 'nowrap',
                    cursor: 'pointer'
                  }}
                >
                  {area.superActivityName}
                </button>
              );
            })}
          </div>
        </div>
        <br></br>
        {!studentId ? (
          <div className="text-center p-4 text-gray-500">
            Please select a student to view activity data.
          </div>
        ) : isLoading ? (
          <div className="text-center p-4 text-blue-600">
            Loading data...
          </div>
        ) : (
          <div style={{ overflowX: "auto" }}>
            <table border="1" cellPadding="8" style={{ borderCollapse: "collapse", minWidth: "800px", width: "max-content" }}>
              <thead>
                <tr>
                  <th style={{ width: '500px' }}>Activity</th>
                  <th>Presented (P)</th>
                  <th>Works with Assistance (WA)</th>
                  <th>Works Independently (WI)</th>
                  <th>Mastered (M)</th>
                </tr>
              </thead>
              <tbody>
                {activityList.map(activity => {
                  const record = activity.activityList[0]; // assuming single student

                  const getStatusCell = (statusCode, activityRecordsId) => {
                    let activityDetails = null;
                    if (activityRecordsId && activityRecordsId.length > 0) {
                      activityDetails = activityRecordsId[0].statusHistory?.find(item => item.key === statusCode);
                    }

                    const bgColor = colorMap[statusCode];

                    return (
                      <td style={{
                        backgroundColor: activityDetails ? bgColor : "transparent",
                        textAlign: "center",
                        fontWeight: "bold",
                        color: activityDetails ? "white" : "black"
                      }}>
                        {activityDetails && activityDetails.changedAt
                          ? new Date(activityDetails.changedAt).toLocaleDateString("en-GB")
                          : "-"}
                      </td>
                    );
                  };

                  return (
                    <tr key={activity.id}>
                      <td style={{
                        backgroundColor: "#F3F4F6",
                        fontWeight: "bold",
                        color: "#111827",
                        textAlign: "left",
                        padding: "8px",
                        verticalAlign: "top"
                      }}>
                        {activity.activityName}
                      </td>
                      {getStatusCell("P", record?.activityRecordsId)}
                      {getStatusCell("WA", record?.activityRecordsId)}
                      {getStatusCell("WI", record?.activityRecordsId)}
                      {getStatusCell("M", record?.activityRecordsId)}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}
      </div>
      {/* <Table>
        <TableHead>
          <TableRow>
            <TableCell><strong>Activity</strong></TableCell>
            {statuses.map(status => (
              <TableCell key={status}><strong>{statusLabels[status]}</strong></TableCell>
            ))}
            <TableCell><strong>Remarks</strong></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((row, rowIndex) => (
            <TableRow key={rowIndex}>
              <TableCell>{row.activity}</TableCell>
              {statuses.map(status => (
                <TableCell key={status}>
                  <TextField
                    type="date"
                    value={row[status]}
                    onChange={(e) => handleDateChange(rowIndex, status, e.target.value)}
                    InputProps={{ style: { width: '140px' } }}
                  />
                </TableCell>
              ))}
              <TableCell>
                <TextField
                  value={row.remarks}
                  onChange={(e) => handleDateChange(rowIndex, 'remarks', e.target.value)}
                  fullWidth
                />
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table> */}
    </Paper>
  );
}
